import { atom } from 'recoil';

const childNameAtom = atom({
    key: 'childName',
    default: null
});

export {
    childNameAtom
};